export default {
  xl      : '40px',
  default : '20px',
  md      : '14px',
  sm      : '12px',
  xs      : '8px',
  xxs     : '4px',
};
